import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRouteModule = ({ children }) => {

    const modulos = useSelector(state => state.modulo.moduloEmpresa);
    const location = useLocation();

    const [redirecionar, setRedirecionar] = useState(false);

    const path = location.pathname;

    useEffect(() => {
        let rotaModulos = [];

        const formatarPath = path.split('/')[1];

        modulos.forEach(empresa => {
            const validarRota = empresa.ATIVO && empresa.CODIGOMODULO === empresa.MODULO.CODIGO;
            const rotaModulo = empresa.MODULO.MODULO;

            if (validarRota) {
                rotaModulos.push(rotaModulo)
            };
        });

        if (!rotaModulos.includes(formatarPath)) {
            setRedirecionar(true);
        };

    }, [path]);

    if (redirecionar) {
        return <Navigate to='/modulos' replace />
    };

    return children;
};

export default PrivateRouteModule;